import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroll-component';
import CircularProgress from '@material-ui/core/CircularProgress';
import { fetchJsonData } from '../ajax';

class InfiniteScroller extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      loaded: false,
      data: [],
      count: 1,
      next: true,
    };

    this.loading = false;
    this._mounted = false;
    this.handleOpen = this.handleOpen.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleOpen() {
    if (!this.state.loaded && !this.loading) {
      this.loadData();
    }
  }

  fetchData = (path, init = {}, onSuccess, onError) => {
    fetchJsonData(
      path,
      init,
      (data) => setTimeout(() => this._mounted && onSuccess?.(data), 500),
      (response, data) =>
        setTimeout(() => this._mounted && onError?.(response, data), 500),
    );
  };

  getRequestPath = () => this.props.requestPath;
  getRequestInit = () => this.props.requestInitProps;

  loadData = () => {
    const { limit } = this.props;
    const { count } = this.state;

    this.fetchData(
      this.getRequestPath() + `?page=${count}`,
      this.getRequestInit(),
      (data) => {
        this.setState(
          (prevState) => ({
            data: [...prevState.data].concat(data),
            next: limit > 0 ? data.length >= limit : data.length > 0,
            count: prevState.count + 1,
            loaded: true,
          }),
          () => (this.loading = false),
        );
      },
      (response, data) => {
        this.loading = false;
      },
    );
  };

  render() {
    const { data = [], next } = this.state;
    const { dataRenderer } = this.props;

    return (
      <div>
        <InfiniteScroll
          next={this.loadData}
          hasMore={next}
          loader={
            <div style={{ textAlign: 'center', marginTop: 16 }}>
              <CircularProgress size={20} />
            </div>
          }
          dataLength={data.length}
        >
          {dataRenderer(data)}
        </InfiniteScroll>
      </div>
    );
  }
}

InfiniteScroller.propTypes = {
  dataRenderer: PropTypes.func.isRequired,
  limit: PropTypes.number,
  requestPath: PropTypes.string,
};

export default InfiniteScroller;
